<!--
    描述：添加字段
    时间：2020-05-20
    Created by ws
-->
<template>
	<div class="w-page-main">
		<div class="w-page-header">
			<searchArea :showMore="false"
						v-model="fieldObj.fieldName"
						@on-search="onSearch"
						@on-refresh="onRefresh"></searchArea>
		</div>

		<div class="w-page-container">
			<div class="w-table-layout w-table-page">
				<div class="w-table-content">
					<el-table :data="fieldObj.tableData"
							  border
                              ref="fieldTable"
							  :height="fieldObj.tableH">
						<el-table-column type="selection"
										 width="60"
                                         align="center">
                        </el-table-column>
						<el-table-column align="center"
										 label="页面元素名称"
                                         prop="title"
                                         show-overflow-tooltip
										 min-width="130">
                        </el-table-column>
                        <el-table-column label="属性编辑"
										 align="center"
										 show-overflow-tooltip
										 width="240">
							<template slot-scope="scope">
								<el-checkbox class="mr10"
											 v-model="scope.row.isSelected"
											 :true-label="1"
											 :false-label="0">显示</el-checkbox>
								<el-checkbox class="mr10"
											 v-model="scope.row.isEditable"
											 :true-label="1"
											 :false-label="0">可编辑</el-checkbox>
								<el-checkbox class="mr10"
											 v-model="scope.row.isRequired"
											 :true-label="1"
											 :false-label="0">必填</el-checkbox>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="w-table-footer">
					<el-pagination @size-change="handleSizeChange"
								   @current-change="handleCurrentChange"
								   :current-page="fieldObj.current"
								   :page-sizes="fieldObj.pageList"
								   :page-size="fieldObj.pageSize"
								   :pager-count="5"
								   layout="total, sizes, prev, pager, next, jumper"
								   :total="fieldObj.total"></el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { $deepCopy } from '@/utils/tools'
import { getPublicFields } from '@/api/modules/analysis'

export default {
	data() {
		return {
			// 字段表格
			fieldObj: {
				fieldName: '',
				tableData: [],
				tableH: 400,
				current: 1,
                pageSize: 10,
                total: 0,
				pageList: [10, 20, 50, 100] // 显示条数数组
			}
		}
    },
    created() {
        this.getData()
    },
	methods: {
		// 获取表格数据
        getData() {
            getPublicFields({
                current: this.fieldObj.current,
                size: this.fieldObj.pageSize,
				formType: '',
				businessType: this.curType,
                title: this.fieldObj.fieldName
            }).then(res => {
                this.fieldObj.tableData = res.data.records
                this.fieldObj.total = parseInt(res.data.total)
            }).catch(err => {

            })
        },
        
        // 获取选中的数据
        getSelectedData() {
            let selection =JSON.parse(JSON.stringify(this.$refs.fieldTable.selection))

            if (selection.length > 0) {
                // 删除ID 字段
                selection.map(x => {
                    delete x.id
                })
                return selection
            } else {
                return []
                this.$message.warning('请选择要添加的字段!')
            }
        },

		// 切换显示条数
		handleSizeChange(val) {
			this.fieldObj.pageSize = val
			this.getData()
		},

		// 切换当前页码
		handleCurrentChange(cur) {
			this.fieldObj.current = cur
			this.getData()
		},

		// 确认搜索
		onSearch() {
			this.getData()
		},

		// 点击刷新
		onRefresh() {
			this.onReset()
			this.onSearch()
		},

		// 点击重置
		onReset() {
			this.fieldObj.fieldName = ''
		}
	},
	computed: {
		curType() {
			let _type = parseInt(this.$route.query.type)
			let _backType = null
			
			switch(_type) {
				case 1:
					_backType = '1010001'
					break
				case 2:
					_backType = '1010002'
					break
				case 3:
					_backType = '1010003'
					break
			}
			return _backType
		}
	}
}
</script>

<style scoped lang="less">
.w-page-main {
    border-bottom: 1px solid #ccc;
    margin-bottom: 8px;
}
</style>
